<template>
  <div
    v-if="error"
    class="error"
  >
    {{ error }}
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ErrorComponent',

  props: {
    error: {
      type: String,
      default: '',
    },
  },
});
</script>

<style scoped lang="scss">
.error {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100000;
  width: 100%;
  height: auto;
  padding: 20px;
  background: #C10015;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<script setup>
</script>
